import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

const ENDPOINT = '/iPIDiagram/';

function mapInputToPayload(data: ParsedValues): APIPayload {
  return {
    title: data.title,
    length: data.length,
    tribWidth: data.tribWidth,
    hingeLength: data.hingeLength,
    totalWeight: data.totalWeight,
    klmFactor: data.klmFactor,
    Ru: data.Ru,
    Xe: data.Xe,
    loadType: data.loadType,
    Pa: data.Pa,
    Ia: data.Ia,
    ductilityLimit: data.ductilityLimit,
    rotationLimit: data.rotationLimit
  };
}

const { analyze, analyzeCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>(ENDPOINT, mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyze, analyzeCancellable };
